
import Vue from '../../plugins/vue';
import Social from './components/Social';

const el = document.getElementById('social');
if (el !== null) {
	new Vue({
		name: 'Social',
		render: h => h(Social, {
			props: {
				title: el.dataset.title ?? '',
				entry: Number.parseInt(el.dataset.entry ?? 0),
				text: el.dataset.text ?? null,
				url: el.dataset.url ?? null,
				authenticated: el.dataset.authenticated ?? 'n',
				isOpen: el.dataset.isOpen == "true"
			}
		})
	}).$mount(el);
}
